import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ghl-page',
  styleUrls: ['./ghl-page.component.scss'],
  template: `
    <iframe
      #ghlFrame
      width="100%"
      height="80%"
      [src]="safeSrc"
      [title]="pageTitle"
      frameborder="0">
    </iframe>
  `
})
export class GhlPageComponent implements OnInit, OnDestroy {
  @Input() baseUrl: string = '';
  @Input() pageTitle: string = 'GHL Page';
  @ViewChild('ghlFrame') frameRef!: ElementRef<HTMLIFrameElement>;

  safeSrc!: SafeResourceUrl;
  private currentUrl: string = '';

  private onMessage = (event: MessageEvent) => {
    if (event.origin !== 'https://pages.propertymatrix.co.za') return;
    if (!event.data || event.data.type !== 'ghl-navigate') return;

    const targetUrl: string = event.data.url;

    history.pushState(
      { ghlStep: this.currentUrl },
      '',
      location.href
    );

    this.currentUrl = targetUrl;
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(targetUrl);
  };

  private onPopState = (event: PopStateEvent) => {
    const ghlStep = event.state?.ghlStep;
    if (ghlStep) {
      this.currentUrl = ghlStep;
      this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(ghlStep);
    }
  };

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data;
    this.baseUrl = data['baseUrl'] || this.baseUrl;
    this.pageTitle = data['pageTitle'] || this.pageTitle;

    this.currentUrl = this.baseUrl;
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl);

    window.addEventListener('message', this.onMessage);
    window.addEventListener('popstate', this.onPopState);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.onMessage);
    window.removeEventListener('popstate', this.onPopState);
  }
}
